import React, { useEffect } from 'react';
import EditLicensePlateLayout from 'feature/license-plates/edit-license-plate-layout';
import {
  useLicensePlateContext,
  CHANGE_PLATE_NUMBER,
  CHANGE_CAR_TYPE,
  CHANGE_ENERGY_SOURCE_TYPE,
  INITIALIZE,
} from 'feature/license-plates/use-license-plate';
import { CAR_TYPE } from 'model/license-plate';
import { FUEL_TYPE } from 'model/energy-source';
import amplitude from 'service/amplitude';

const NewLicensePlate = () => {
  const { state, dispatch, addLicensePlate, redirectAfterAddPlate } = useLicensePlateContext();

  useEffect(() => {
    dispatch({ type: INITIALIZE, payload: { plateNumber: '', vehicleType: CAR_TYPE.key, energySource: FUEL_TYPE.key } });
  }, []);

  const onTextChanged = text => {
    dispatch({ type: CHANGE_PLATE_NUMBER, payload: text });
  };

  const onTypeChanged = type => {
    amplitude.plateNumber_add_type_onClick();
    dispatch({ type: CHANGE_CAR_TYPE, payload: type });
  };

  const onEnergySourceChange = type => {
    dispatch({ type: CHANGE_ENERGY_SOURCE_TYPE, payload: type });
  };

  const onFocus = () => amplitude.plateNumber_add_plate_onClick();

  const onSubmit = () => {
    amplitude.plateNumber_add_complete_onClick();
    addLicensePlate({ payload: state });
  };

  return (
    <EditLicensePlateLayout
      plateNumber={state.plateNumber}
      vehicleType={state.vehicleType}
      energySource={state.energySource}
      onEnergySourceChange={onEnergySourceChange}
      onTextChanged={onTextChanged}
      errorMessage={state.plateNumberErrorMessage}
      onRadioClick={onTypeChanged}
      onClick={onSubmit}
      onFocus={onFocus}
      btnLoading={state.loading}
      rentalPlateDialogShow={state.showRentalPlateDialog}
      rentalPlateDialogOnClick={redirectAfterAddPlate}
    />
  );
};

export default NewLicensePlate;
